<dx-popup [title]="'logs.popupTitle' | translate" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view id="scrollview">
            <div class="form">
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.information</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblEnvironment</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.environmentName"/>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblTransfer</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.fileTransferName"/>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblDateUtc</div>
                        <div class="dx-field-value">
                            <dx-date-box displayFormat="MMMM d, yyyy HH:mm:ss" [readOnly]="true" [value]="displayedLog?.transferDate"/>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblType</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayLogType(displayedLog)"/>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblLocalAgentName</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.localAgent.name"/>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset" *ngIf="displayedLog?.sourceFileName">
                    <div class="dx-fieldset-header" translate>_commons.file</div>
                    <div class="dx-field" *ngIf="displayedLog?.sourceFileName">
                        <div class="dx-field-label" translate>logs.lblSourceFileName</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.sourceFileName"/>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="displayedLog?.sourceFileSize">
                        <div class="dx-field-label" translate>logs.lblSourceFileSizeKb</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.sourceFileSize?.toFixed(2)" [width]="150" [inputAttr]="{ 'style': 'text-align: right !important;' }"/>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="displayedLog?.targetFileName">
                        <div class="dx-field-label" translate>logs.lblTargetFileName</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.targetFileName"/>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="displayedLog?.targetFileSize">
                        <div class="dx-field-label" translate>logs.lblTargetFileSizeKb</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.targetFileSize?.toFixed(2)" [width]="150" [inputAttr]="{ 'style': 'text-align: right !important;' }"/>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="displayedLog?.hasArchivedFile">
                        <div class="dx-field-label" translate>logs.lblArchivedFileName</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.archivedFileName"/>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="displayedLog?.archivedFileSize">
                        <div class="dx-field-label" translate>logs.lblArchivedFileSizeKb</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.archivedFileSize?.toFixed(2)" [width]="150" [inputAttr]="{ 'style': 'text-align: right !important;' }"/>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset" *ngIf="displayedLog?.details">
                    <div class="dx-fieldset-header" translate>_commons.details</div>
                    <div class="dx-field">
                        <dx-text-area class="dx-field-value" [value]="displayedLog?.details" height="250px" width="100%"/>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"/>
        </div>
    </div>
</dx-popup>